





































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import clientConfigService from '@/clients/services/client-config-service'
import pushService from '@/clients/services/push-service'
import ClientConfig from '@/clients/entities/client-config'
import SendPushDialog from '@/clients/components/send-push-dialog.vue'
import PushMessage from '@/clients/entities/push-message'
import snacks from '@/app/services/snacks'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import HistoryEntry from '@/history/models/HistoryEntry'
import historyService from '@/history/services/history-service'
import HistoryFilter from '@/history/models/HistoryFilter'
import PaginationRequest from '@/common/pagination/entities/pagination-request'
import { isEqual } from 'lodash'

@Component
export default class Home extends Vue {
  @Ref()
  private pushDialog!: SendPushDialog

  private loading: boolean = false
  private configs: ClientConfig[] = []
  private history: HistoryEntry[] = []

  private filter: HistoryFilter = new HistoryFilter()

  @Watch('filter.paging')
  private async filterPagingChanged(
    val: PaginationRequest,
    old: PaginationRequest
  ) {
    if (isEqual(val, old) === false) {
      await this.fetchAll()
    }
  }

  private async fetchAll() {
    this.loading = true
    this.configs = await clientConfigService.findAllProductiveAsync()
    const response = await historyService.findAllProductiveAsync(this.filter)
    this.filter.paging.totalItems = response.totalItems
    this.history = response.items
    this.loading = false
  }

  private async fetchHistory() {
    this.loading = true
  }

  private async openSend(config: ClientConfig) {
    this.pushDialog.open(config)
  }

  private async send(config: ClientConfig, message: PushMessage) {
    await pushService.sendAsync(config, message)
    snacks.success(this.$tc('clients.pages.clients.send.success'))
  }

  private async mounted() {
    await this.fetchAll()
  }
}
